import { render } from "./AIAssistant.vue?vue&type=template&id=5af91cc7&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=5af91cc7&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=5af91cc7&lang=scss"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af91cc7"]])

export default __exports__